import React from 'react';
import './nav-header.scss';

import { LogoSkySport, LogoSkyTg24 } from '../../atoms';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import NavHeaderFilters from '../../molecules/nav-header-filters/nav-header-filters';
import { ISubSection } from '../../../typings/hlroom';
import TypograpyHeadingComponent from '../../foundation/typography/typography-heading/typography-heading';
import { configTemplates } from '../../templates';

export interface INavHeader {
  isDesktop: boolean;
  allFilterVisible: boolean;
  subSections: ISubSection[];
  subSectionIndex: number;
  onSubSectionChange: (subSection: ISubSection) => void;
  href: string;
  appType?: string;
}

const NavHeader: React.FC<INavHeader> = ({
  subSections,
  subSectionIndex,
  onSubSectionChange,
  isDesktop,
  allFilterVisible,
  href,
  appType = 'sport',
}) => {
  const classNames = (isDesktop: boolean): IClassNames =>
    makeClassNames({
      navHeader: [
        'nav-header',
        isDesktop && 'nav-header__desktop',
        !isDesktop && allFilterVisible && appType === 'sport' && 'nav-header__no-filter',
      ],
      navHeaderGrid: ['l-inner-grid'],
      navHeaderTitle: ['nav-header__title'],
      navHeaderGridInner: 'l-inner-grid__main',
      navHeaderLogo: 'nav-header__logo',
      navHeaderWrapper: 'nav-header__wrapper',
      navHeaderSections: 'nav-header__sections',
    });
  const cn = classNames(isDesktop);

  // const title = 'Skylights Room';
  return (
    <div className={cn.navHeader}>
      <div className={cn.navHeaderGrid}>
        <div className={cn.navHeaderGridInner}>
          <div className={cn.navHeaderWrapper}>
            <nav className={cn.navHeaderLogo}>
              <a href={href} target="_self">
                {appType === 'sport' && (
                  <LogoSkySport verticalAlign="middle" color="light" size={isDesktop ? 'medium' : 'small'} />
                )}
                {appType === 'tg24' && <LogoSkyTg24 verticalAlign="middle" color="light" size="small" />}
                <div className={cn.navHeaderTitle}>
                  <TypograpyHeadingComponent
                    customFont={appType === 'tg24' ? 'ty-heading--s' : 'skyHeadline--s'}
                    headingTag="h1"
                    text={configTemplates[appType].title}
                  />
                </div>
              </a>
            </nav>
            <nav className={cn.navHeaderSections}>
              <NavHeaderFilters
                isDesktop={isDesktop}
                subSections={subSections}
                subSectionIndex={subSectionIndex}
                showFilters={allFilterVisible}
                onSubSectionChange={onSubSectionChange}
                appType={appType}
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavHeader;
